export default __webpack_public_path__ + "static/media/modal-banner-1.fb277a0f.png";